import React, { useState, useEffect } from "react";
import { object } from "prop-types";
import { StoryPageBase } from "./story";

const StoryPagePreview = ({ config }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    global.addEventListener("message", event => {
      if (event.data.story) {
        setData({
          story: event.data.story,
          relatedStories: Array(4).fill(event.data),
          preview: true,
          index: 0
        });
      }
    });
  }, []);

  if (!data.story) return <div />;
  return StoryPageBase(data, config);
};

StoryPagePreview.propTypes = {
  config: object
};

export { StoryPagePreview };
